var CurrentUser = require("lib/account/CurrentUser");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var DropDownOptions = require("components/utility/DropDownOptions");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");

class ReadingLevelFormatPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	buildSelectReadingLevelF(readingLevel) {
		return function() {
			var newPrefs = { reading_level_format: readingLevel };
			var params = { admin: { prefs: newPrefs }};
			CurrentUser.updateLocal({ prefs: newPrefs });

			this.forceUpdate()
			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited",
				text: "You successfully changed your reading level format.",
				icon: "ok-sign"
			});

			CurrentUser.api().patchAdmin(CurrentUser.get().id, params, $wr.apiHandler(function(response){
				CurrentUser.fetchCurrentUserData();
			}.bind(this)));
		}.bind(this);
	}

	render() {
		var currentReadingLevelFormat = CurrentUser.get().prefs.reading_level_format;

		var readingLevelOptions = [];
		_.each(ReadingLevelFormatPreference.READING_LEVEL_OPTIONS, function(levelOption) {
			readingLevelOptions.push(
				<ButtonDropdownOption onClick={ this.buildSelectReadingLevelF(levelOption) }
					text={ levelOption } key={ levelOption } />
			);
		}.bind(this));

		var readingLevelDropdown = (
			<ButtonDropdown text={ currentReadingLevelFormat } className="readingLevelsPicker">
				{ readingLevelOptions }
			</ButtonDropdown>
		);

		// <p className="smallText">
			// 	Please note: Our default system is Lexile. The conversion to other systems can be inexact.
		// </p>

		return (
			<div className="readingLevelPickerContainer">
				<p className="subTitle">Format</p>
				<div>
					Select the format you use for your students' reading levels.
				</div>
				{ readingLevelDropdown }
			</div>
		)
	}

}

ReadingLevelFormatPreference.READING_LEVEL_OPTIONS = ["Lexile Level", "Grade", "Ages",
	"Reading Recovery", "DRA", "Rigby Literacy Levels", "Rigby PM", "Reading A-Z Level",
	"Fountas & Pinnell"];

ReadingLevelFormatPreference.propTypes = StrictPropTypes({
	onChange: PropTypes.func.isRequired
});

module.exports = ReadingLevelFormatPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/ReadingLevelFormatPreference.js